import { render, staticRenderFns } from "./QuestionnaireFormatPageRelocator.vue?vue&type=template&id=7add3c82&scoped=true&"
import script from "./QuestionnaireFormatPageRelocator.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageRelocator.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageRelocator.vue?vue&type=style&index=0&id=7add3c82&lang=scss&scoped=true&"
import style1 from "./QuestionnaireFormatPageRelocator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add3c82",
  null
  
)

export default component.exports